<template>
    <div id="Console">
        <el-card shadow="never">
            <el-row>
                <el-col :span="8">
                    <el-button-group>
                        <el-button
                            type="info"
                            icon="el-icon-refresh"
                            @click="refreshTypes"
                            >刷新</el-button
                        >
                    </el-button-group>
                </el-col>
                <!-- <el-col :span="6" class="serch-input" style="float:right;">
                        <el-input placeholder="请输入类型编号" v-model="input5" class="input-with-select" clearable>
                        </el-input>
                    </el-col> -->
            </el-row>
            <el-table 
                :data="orderTimeList" 
                border 
                style="width: 100%"  
                v-loading="loading"
                element-loading-text="努力加载中"
                element-loading-spinner="el-icon-loading">
                <el-table-column prop="orderOutTime" label="订单超时时间(s)">
                </el-table-column>
                <el-table-column prop="orderPayListenTime" label="订单请求时间(s)">
                </el-table-column>
                <el-table-column
                    prop="operation"
                    label="操作"
                    header-align="center"
                >
                    <template slot-scope="scope">
                        <el-row>
                            <el-button-group>
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    content="修改"
                                    placement="bottom"
                                >
                                    <el-button
                                        @click.native.prevent="
                                            revise(scope.$index, scope.row)
                                        "
                                        type="info"
                                        size="small"
                                        plain
                                        icon="el-icon-edit"
                                        class="operateBtn"
                                    ></el-button>
                                </el-tooltip>
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    content="删除"
                                    placement="bottom"
                                >
                                    <el-button
                                        type="danger"
                                        size="small"
                                        icon="el-icon-delete"
                                        @click.native.prevent="
                                            deleteLocationRow(
                                                scope.$index,
                                                locationData
                                            )
                                        "
                                        class="operateBtn"
                                    ></el-button>
                                </el-tooltip>
                            </el-button-group>
                        </el-row>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
    </div>
</template>

<script>
import requestMixin from '../../mixins/request'
import common from '../../mixins/common'
import axios from '../../env/axios'
import apis from '../../env/apis';
export default {
    mixins: [requestMixin, common],
    data () {
        return {
            orderTimeList: [],
            loading:false

        }
    },
    mounted(){
        this.$nextTick(() => {
            this.refreshTypes();
        })
    },
    methods: {
        revise (index, row) {
            // console.log('修改')
            // console.log(index,row)
            this.$router.push({
                    path:'/system/editOrderTime',
                    query:{
                        index
                    }
            })
        },
        //刷新
        refreshTypes () {
            let that = this;
            let userId = sessionStorage.getItem('userId');
            let params = {
                act:'getSysSetting',
                userId
            }
            that.loading = true;
            that.delType(params).then((res) => {
                let { code,data } = res.data;
                if(code == 200){
                    that.loading = false;
                    that.orderTimeList = [data];
                }
            }).catch((error) => {
                that.loading =  false;
                that.$alert('请求不到数据或网络连接异常', '提示', {
                    confirmButtonText: '确定',
                    type: 'error',
                    center: true
                })
            })
        }
    }
}
</script>

<style lang="" scoped>
</style>